<template>
  <div class="setup_shop">
    <!--店铺设置头部-->
    <div class="setup_shop_top">
      <div><input type="text" v-model.trim="name" title="店铺名称" placeholder="店铺名称"></div>
      <div><input type="text" v-model.trim="nick" title="店铺昵称" placeholder="店铺昵称"></div>
      <div><input type="text" v-model.trim="appkey" title="appkey" placeholder="appkey"></div>
      <div>
        <el-select v-model="selectSource" placeholder="请选择">
          <el-option
            v-for="item in shopSourceList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <button class="btn_normal ml20" @click="queryData()">查询</button>
      <button class="btn_normal ml20" @click="ctrlBtn('addShop', null)">新增店铺</button>
    </div>

    <!--店铺设置信息-->
    <div class="setup_shop_msg">
      <!--表格-->
      <table class="table">
        <thead>
        <tr>
          <th>店铺名称</th>
          <th>整店库存</th>
          <th>店铺昵称</th>
          <th>店铺ID</th>
          <th>来源</th>
          <th>密钥</th>
          <!--<th>appkey</th>-->
          <!--<th>appSecret</th>-->
          <!--<th>sessionKey</th>-->
          <th>？启用</th>
          <th>平台状态</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody v-if="shopList.length">
        <tr v-for="(item, index) in shopList" :key="index">
          <td>{{item.ShopName}}</td>
          <!--{{inventoryTxt}}-->
          <td v-if="!item.IsShopStockUpdate"><a v-if="item.CheckStatus === 2 && item.PFLockStatus === 1" title="同步库存" @click="ctrlBtn('synchronousInventory', item)">同步库存</a></td>
          <td v-if="item.IsShopStockUpdate"><a title="正在同步库存中">{{item.BeginShopStockUpdateTime | time}}</a></td>
          <td>{{item.ShopNick}}</td>
          <td>{{item.OutShopId}}</td>
          <td>{{item.PlatformName}}</td>
          <td><a v-if="item.AppKey" @click="ctrlBtn('checkTheKey', item)">查看</a></td>
          <!--<td class="app_key_txt_td"><p class="app_key_txt" :title="item.AppKey">{{item.AppKey}}</p></td>-->
          <!--<td><a title="查看详情" @click="ctrlBtn('appSecret', item)">查看详情</a></td>-->
          <!--<td><a title="查看详情" @click="ctrlBtn('sessionKey', item)">查看详情</a></td>-->
          <td>{{item.LockStatus | status}}</td>
          <td v-if="item.CheckStatus === 1">待审</td>
          <!--<td v-if="item.CheckStatus === 2 && item.PFLockStatus === 1">审核通过</td>-->
          <td v-if="item.CheckStatus === 2 && item.PFLockStatus === 1">正常</td>
          <td v-if="item.CheckStatus === 2 && item.PFLockStatus === 2">锁定中</td>
          <td v-if="item.CheckStatus === 3">审核拒绝</td>
          <td>
            <div>
              <a title="订单设置" v-if="item.CheckStatus === 2 && item.PFLockStatus === 1" @click="ctrlBtn('orderSetting', item)">订单设置</a>
              <a title="配置对接渠道" v-if="item.CheckStatus === 2 && item.PFLockStatus === 1" @click="ctrlBtn('configureChannels', item)">渠道设置</a>
              <a title="编辑" v-if="item.CheckStatus === 2 && item.PFLockStatus === 1" @click="ctrlBtn('modifyShop', item)">编辑</a>
              <a title="启用" v-if="item.LockStatus === 2 && item.CheckStatus === 2 && item.PFLockStatus === 1" @click="ctrlBtn('enableShop', item)">启用</a>
              <a title="拒绝原因" v-if="item.CheckStatus === 3" @click="ctrlBtn('refusedReason', item)">查看拒绝原因</a>
              <a title="删除" v-if="(item.LockStatus === 2 && item.CheckStatus === 3) || (item.LockStatus === 2 && item.CheckStatus === 2 && item.PFLockStatus === 1)" @click="ctrlBtn('delShop', item)">删除</a>
              <a title="停用" v-if="item.LockStatus === 1" @click="ctrlBtn('disableShop', item)">停用</a>
              <!--<a title="授权" v-if="item.CheckStatus === 2 && item.PFLockStatus === 1">授权</a>-->
            </div>
          </td>
        </tr>
        </tbody>
        <tbody v-if="!shopList.length">
        <tr>
          <td colspan="9">暂时没有相关的数据</td>
        </tr>
        </tbody>
      </table>

      <!--分页-->
      <div class="text_right mt20" v-if="shopList.length">
        <el-pagination
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!--弹出框-->
    <setup-shop-embed-msg v-if="isShow" :title="dialogTitle" :shopMsg="shopMsg"
                          :showType="dialogShowType" @cancelbtn="getSelectDialogEmbed"></setup-shop-embed-msg>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>
  </div>
</template>

<script type="es6">
  import SetupShopEmbedMsg from './setup-shop-embed-msg';
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: 'setup-shop',
    components: {SetupShopEmbedMsg, MsgDialog, LoadingDialog},
    data() {
      return {
        shopList: [], // 店铺列表
        name: '', // 店铺名称
        nick: '', // 店铺昵称
        appkey: '', // appkey
        shopSourceList: [], // 下拉店铺来源列表
        selectSource: '', // 选择的店铺来源
        inventoryTxt: '同步库存', // 同步库存的文字
        shopMsg: null, // 店铺信息
        isLoading: false, // 是否显示加载框
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 0, // 总条数
        currentTimer: '' // 当前动态时间的计数器
      }
    },
    methods: {
      // 获取平台来源下拉框信息
      getAllPXOpenPlatformList() {
        this.$axios.get(this.Global.getAllPXOpenPlatformList).then((res) => {
          console.log(res);
          if (!res.data.errorMsg.length) {
            this.shopSourceList = res.data.resData;
            this.shopSourceList.splice(0, 0, {id: '', text: '所有来源'});
            this.selectSource = '';
          } else {
            this.shopSourceList = [];
            this.selectSource = res.data.errorMsg;
          }
        });
      },

      // 根据店铺名称 + 店铺昵称 + appkey + 店铺来源 查询店铺分页数据
      queryData() {
        this.currentPage = 1;
        this.loadAgentShopPageData();
      },

      // 获取店铺分页数据
      loadAgentShopPageData() {
        this.isLoading = true;
        const params = {
          ShopName: this.name,
          ShopNick: this.nick,
          PlatformId: this.selectSource,
          Appkey: this.appkey,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.loadAgentShopPageData, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            clearTimeout(timer);
            if (res.data) {
              if (!res.data.errorMsg.length) {
                self.shopList = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
                /* self.$router.push({
                  path: '/home/s_setup',
                  query: {
                    name: this.name,
                    nick: this.nick,
                    selectSource: selectSource,
                    appkey: this.appkey,
                    currentPage: this.currentPage,
                    pageSize: this.pageSize
                  }
                }); */
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
                self.shopList = [];
                self.total = 0;
              }
            }
          }, 500);
          this.Global.tabsChange(this.$route, '店铺设置');
        });
      },

      // 操作按钮
      ctrlBtn(type, msg) {
        this.isShow = true;
        this.dialogShowType = type;
        this.shopMsg = msg;
        switch (type) {
          case 'addShop':
            this.dialogTitle = '新增店铺';
            break;
          case 'modifyShop':
            this.dialogTitle = '编辑店铺';
            break;
          case 'configureChannels':
            this.dialogTitle = '配置店铺对接渠道';
            break;
          case 'orderSetting':
            this.dialogTitle = '同步订单设置';
            break;
          case 'refusedReason':
            this.dialogTitle = '查看店铺申请拒绝原因';
            break;
          case 'checkTheKey':
            this.dialogTitle = '查看密钥';
            break;
          default:
            this.dialogTitle = '提示';
            break;
        }
      },

      // 时间个位数变为两位数
      changeTwoDigits(num) {
        if (num === 0 || (num > 0 && num < 10)) {
          return '0' + num;
        } else {
          return num;
        }
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
        if (e.handleType) {
          this.loadAgentShopPageData();
          if (this.dialogShowType === 'synchronousInventory' && e.issure) {
            let times = 3;
            const self = this;
            let currentDT = new Date();
            this.inventoryTxt = currentDT.getFullYear() + '/' + this.changeTwoDigits((currentDT.getMonth() + 1)) + '/' +
              this.changeTwoDigits(currentDT.getDate()) + '  ' + this.changeTwoDigits(currentDT.getHours()) + ':' +
              this.changeTwoDigits(currentDT.getMinutes()) + ':' + this.changeTwoDigits(currentDT.getSeconds());
            const timer = setInterval(function () {
              times = --times;
              if (times < 1) {
                self.inventoryTxt = '同步库存';
                clearInterval(timer);
              }
            }, 1000);
          }
        }
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        this.loadAgentShopPageData();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.loadAgentShopPageData();
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    },
    created() {
      this.loadAgentShopPageData();
      this.getAllPXOpenPlatformList();
    },
    activated() { // 只有keep-alive激活才会被使用
      if (sessionStorage.getItem('isRefresh') === 'true') { // 从左边的菜单进去刷新页面
        sessionStorage.setItem('isRefresh', 'false');
        this.shopList = [];
        this.name = '';
        this.nick = '';
        this.appkey = '';
        this.selectSource = '';
        this.isShow = false;
        this.currentPage = 1;
        this.pageSize = 10;
        this.total = 0;
        this.loadAgentShopPageData();
      }
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/base-color";
  @import "../../../assets/css/home-view";

  .setup_shop {
    .setup_shop_msg {
      .table {
        td, th {
          border: 1px solid #ddd;
        }
        td {
          div {
            /*width: 305px;*/
            width: 250px;
            margin: auto;
            text-align: left;
          }

          &.app_key_txt_td {
            width: 10%;
            max-width: 280px;

            .app_key_txt {
              width: 100%;
              word-wrap: break-word;
              word-break: normal;
              text-align: center;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/system-based/setup-shop.vue